const comissionsResources = {
  en: {
    comissions: {
      title: 'The amount of commission fees of insurance agents',
      table1: 'Insurance Class',
      table2: 'Minimum amount of agency remuneration',
      table3: 'Maximum amount of agency remuneration',
      table4: 'Note',
      fiz: 'for individuals, SP and PF',
      else: 'with the exception of state bodies, state institutions, state-owned enterprises, legal entities, fifty percent or more of the voting shares (participation shares in the authorized capital) of which belong to the state, and legal entities affiliated with them',
      item1: '101 Compulsory insurance of civil liability of vehicle owners',
      item2:
        '101 Compulsory insurance of civil liability of vehicle owners (temporary entry)',
      item3:
        '102 Compulsory insurance of civil liability of the carrier to passengers',
      item4: '105 Compulsory environmental insurance',
      item5:
        '108 Compulsory insurance of civil liability of owners of facilities whose activity are associated with the risk of harm to third parties',
      item6: '203 Accident insurance',
      item7: '204 Sickness insurance',
      item8: '301 Motor transport insurance',
      item9: '302 Railway transport insurance',
      item10: '303 Air transport insurance',
      item11: '304 insurance of water transport',
      item12: '305 Insurance of space objects',
      item13: '306 Cargo insurance in',
      item14:
        '307 Insurance of property against damage, except for the classes specified in lines 3.1-3.6',
      item15: '308 Insurance of civil liability of owners of motor transport',
      item16: '309 Insurance of civil liability of air transport owners',
      item17: '310 insurance of civil liability of owners of water transport',
      item18: '311 Insurance of civil liability of owners of space objectsk',
      item19: '312 Professional liability insurance',
      item20:
        '313 GPO insurance, except for the classes specified in paragraphs 3.8-3.12',
      item21: '314 Loan insurance',
      item22:
        '317 Insurance against other financial losses (including interruption of production)',
      item23:
        '318 Insurance of losses of financial organizations, with the exception of paragraphs 3.14-3.17',
      item24: '319 Title insurance',
      file: 'https://api.jgarant.kz/cdn/0b00e75614154bbdbb94acfc2773a908.pdf',
    },
  },
  kz: {
    comissions: {
      title: 'Сақтандыру агенттерінің комиссиялық сыйақы мөлшері',
      table1: 'Сақтандыру жіктелімі',
      table2: 'Агенттік сыйақының ең төменге мөлшері',
      table3: 'Агенттік сыйақының ең жоғары мөлшері',
      table4: 'Ескертпе',
      fiz: 'Жеке тұлғалар, ЖК және ШҚ үшін',
      else: 'дауыс беретін  акцияларының (жарғылық капиталға қатысу үлестерінің) елу және одан да көп пайызы мемлекетке тиесілі мемлекеттік органдарды, мемлекеттік мекемелерді, мемлекеттік кәсіпорындарды, заңды тұлғаларды және олармен үлестес заңды тұлғаларды қоспағанда',
      item1:
        '101 Көлік құралдары иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру',
      item2:
        '101 Көлік құралдары иелерінің азаматтық-құқықтыұ жауапкершілігін міндетті сақтандыру (уақытша кіру)',
      item3:
        '102 Тасымалдаушының жолаушылар алдындағы азаматтық-құқықтық жауапкершілігін міндетті сақтандыру',
      item4: '105 Міндетті экологиялық сақтандыру',
      item5:
        '108 Қызметі үшінші тұлғаларға зиян келтіру қаупімен байланысты, объектілер иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру',
      item6: '203 Жазатайым оқиғалардан сақтандыру',
      item7: '204 Ауырған жағдайда сақтандыру',
      item8: '301 Автомобиль көлігін сақтандыру',
      item9: '302 Теміржол көлігін сақтандыру',
      item10: '303 Әуе көлігін сақтандыру',
      item11: '304 Су көлігін сақтандыру',
      item12: '305 Ғарыш объектілерін сақтандыру',
      item13: '306 В жүктерін сақтандыру',
      item14:
        '307 3.1-3.6-жолдарда көрсетілген сыныптарды қоспағанда, мүлікті залалдан сақтандыру',
      item15:
        '308 Автомобиль көлігі иелерінің азаматтық-құқықтық жауапкершілігін сақтандыру ',
      item16:
        '309 Әуе көлігі иелерінің азаматтық-құқықтық жауапкершілігін сақтандыру',
      item17:
        '310 Су көлігі иелерінің азаматтық-құқықтық жауапкершілігін сақтандыру',
      item18:
        '311 Ғарыш объектілері иелерінің азаматтық-құқықтық жауапкершілігін сақтандыру',
      item19: '312 Кәсіби жауапкершілікті сақтандыру',
      item20:
        '313 3.8-3.12-жолдарда көрсетілген сыныптарды қоспағанда, АҚЖ-ны сақтандыру',
      item21: '314 Заемдарды сақтандыру',
      item22:
        '317 (Өндірістегі үзілісті қоса алғанда) өзге де қаржы шығындарын сақтандыру',
      item23:
        '318 3.14-3.17 тармақтарды қоспағанда, қаржы ұйымдарының шығындарын сақтандыру\t',
      item24: '319 Титулдық сақтандыру',
      file: 'https://api.jgarant.kz/cdn/61beaac1daba482a9bcbd8d67bb59a6a.pdf',
    },
  },
  ru: {
    comissions: {
      title: 'Размеры комиссионных вознаграждений страховых агентов',
      table1: 'Класс Страхования',
      table2: 'Минимальный размер агентского вознаграждения',
      table3: 'Максимальный размер агентского вознаграждения',
      table4: 'Примечание',
      fiz: 'для физических лиц, ИП и КХ',
      else: 'за исключением государственных органов, государственных учреждений, государственных предприятий, юридических лиц, пятьдесят и более процентов голосующих акций (долей участия в уставном капитале) которых принадлежат государству, и аффилированные с ними юридические лица',
      item1:
        '101 Обязательное страхование гражданско-правовой ответственности владельцев транспортных средств',
      item2:
        '101 Обязательное страхование гражданско-правовой ответственности владельцев транспортных средств (временный въезд)',
      item3:
        '102 Обязательное страхование гражданско-правовой ответственности перевозчика перед пассажирами',
      item4: '105 Обязательное экологическое страхование',
      item5:
        '108 Обязательное страхование гражданско-правовой ответственности владельцев объектов, деятельность которых связана с опасностью причинения вреда третьим лицам',
      item6: '203 Страхование от несчастных случаев',
      item7: '204 Страхование на случай болезни',
      item8: '301 Страхование автомобильного транспорта',
      item9: '302 Страхование железнодорожного транспорта',
      item10: '303 страхование воздушного транспорта',
      item11: '304 страхование водного транспорт',
      item12: '305 Страхование космических объектов',
      item13: '306 Страхование грузов в',
      item14:
        '307 Страхование имущества от ущерба, за исключением классов, указанных в строках 3.1-3.6',
      item15:
        '308 Страхование гражданско-правовой ответственности владельцев автомобильного транспорта',
      item16:
        '309 Страхование гражданско-правовой ответственности владельцев воздушного транспорта',
      item17:
        '310 страхование гражданско-правовой ответственности владельцев водного транспорта',
      item18:
        '311 Страхование гражданско-правовой ответственности владельцев космических объектов',
      item19: '312 Страхование профессиональной ответственности',
      item20:
        '313 Страхование гпо, за исключением классов, указанных в пунктах 3.8-3.12',
      item21: '314 Страхование займов',
      item22:
        '317 Страхование от прочих финансовых убытков (включая перерыв в производстве)',
      item23:
        '318 Страхование убытков финансовых организаций, за исключением пунктов 3.14-3.17',
      item24: '319 Титульное страхование',
      file: 'https://api.jgarant.kz/cdn/0b00e75614154bbdbb94acfc2773a908.pdf',
    },
  },
};

export default comissionsResources;
